export {}

export const STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
}
export const VALUE_INACTIVE = 'Inactive'
export const VALUE_CARD = 'card'
export const VALUE_CARD_UPPER = 'Card'
export const TAB_TEMPLATE = [
  { key: 'imagePreviewUrl', label: 'Preview' },
  { key: 'cardType', label: 'Card Type' },
  { key: 'cardName', label: 'Template Name' },
  { key: 'createdAt', label: 'Created At' },
  { key: 'updatedAt', label: 'Updated At' },
  { key: 'status', label: 'Status' },
  { key: 'action', label: 'Action' }
]
export const TOTAL_SCAN = 'totalScan'
export const defaultPage = 1
export const defaultPageSize = 10
export const pageSizeOptions = [
  { value: 10, label: '10' },
  { value: 20, label: '20' },
  { value: 50, label: '50' },
  { value: 100, label: '100' },
] 

export const TEMPLATE_NAME_TOOLTIP = "This will be used for you to identify the card in your reports we will also add the users Name to the end of each card."
